/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { FixedSizeList as List } from 'react-window';
import { ReactComponent as NoOptions } from 'shared/img/icons/no-options.svg';
import classes from './empyOptions.module.scss';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@pileus-cloud/anodot-frontend-common';
import styles from '~/shared/components/FilterSidebar/FieldSidebarFilter.module.scss';

const height = 40;

export default class MenuList extends Component {
  render() {
    const { options, children, maxHeight, getValue, selectProps } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;
    const innerTextStyle = {
      // overflowY: 'scroll',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    };
    if (!children?.length) {
      return (
        <div className={classes.emptyStateWrapper}>
          <NoOptions />
          <span>{options?.length ? 'No Results' : 'No Data Found'}</span>
        </div>
      );
    }
    const renderBody = (tab) => {
      const childrenFiltered = !tab ? children : children.filter((ch) => ch.props.data?.tab === tab);
      return (
        <List
          height={Math.min(maxHeight, height * childrenFiltered.length, height * 5)}
          itemCount={childrenFiltered.length}
          itemSize={height}
          initialScrollOffset={initialOffset}
        >
          {({ index, style }) => <div style={{ ...style, ...innerTextStyle }}>{childrenFiltered[index]}</div>}
        </List>
      );
    };
    if (selectProps?.tabs?.length) {
      return (
        <Tabs defaultValue={selectProps.tabs[0]}>
          <TabsList className={styles.navbar}>
            {selectProps.tabs.map((tab) => (
              <TabsTrigger key={tab} value={tab} className={styles.navbarButton}>
                {tab}
              </TabsTrigger>
            ))}
          </TabsList>
          {selectProps.tabs.map((tab) => (
            <TabsContent value={tab} key={tab} className={styles.tabContent}>
              {renderBody(tab)}
            </TabsContent>
          ))}
        </Tabs>
      );
    }
    return renderBody();
  }
}
